export function matchesAttribute(collection, attributeName, attributeValue) {
  const normalizedValue = attributeValue?.toLowerCase();
  const fieldName = attributeName?.toLowerCase();

  const fieldValue = collection[fieldName];
  if (fieldValue) {
    if (Array.isArray(fieldValue)) {
      return fieldValue.some((val) => val?.toLowerCase() === normalizedValue);
    }
    if (typeof fieldValue === 'string') {
      return fieldValue.toLowerCase() === normalizedValue;
    }
  }

  const secondaryAttr = collection.secondary_attribute;
  if (Array.isArray(secondaryAttr)) {
    return secondaryAttr.some((val) => val?.toLowerCase() === normalizedValue);
  }

  return secondaryAttr?.toLowerCase() === normalizedValue;
}
